export default {
  TRIAL: '',
  BASIC: 'bsc',
  BASIC_PLUS: 'bscp',
  ADVANCED: 'adv',
  PREMIUM: 'prm',
}
